module.exports = __webpack_public_path__ + "static/media/chatapp.f485c12c.gif";